var _circle, _path, _rect, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBattery50(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 31.5,
    transform: "translate(31.5 31.5)",
    fill: "#393c46",
    fillOpacity: 0.32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3327,18.6666h-5v-3.3333h-6.6667v3.3333h-5v30h16.6667v-30Z",
    fill: "#61656e"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16.6667,
    height: 1.66667,
    rx: 0,
    ry: 0,
    transform: "matrix(1 0 0 10.07986 23.667 31.94457)",
    fill: "#c75454"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.076,42.4164c-.243,0-.4305-.3013-.3958-.6416l.625-6.1639h-2.4305c-.6112,0-.2292-.7292-.2153-.7583.875-2.1681,2.1875-5.3764,3.9236-9.6542.0467-.1123.1198-.1983.2069-.2435.087-.0452.1825-.0466.2702-.0042s.1622.1263.2107.237c.0485.1108.068.2417.0552.3704l-.625,6.1639h2.4375c.2778,0,.4306.1847.2778.6417-2.2847,5.5805-3.6111,8.8375-3.993,9.7708-.0695.175-.2014.2819-.3473.2819Z",
    fill: "#1e2330"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery50);
export default __webpack_public_path__ + "static/media/Battery-50.72b37612cf3431f68f91fa51cd735285.svg";
export { ForwardRef as ReactComponent };